<main>
    <div *ngIf="pageContent" class="apple-certificate-upload">
        <h1>{{pageContent.heading}} </h1>
        <div *ngIf="notiContent.type" class="alert valign-children-middle error-container" >
            <div class="alert-{{notiContent.type}}" role="img" aria-label="Error">
              <i [ngClass]="{'icon-badgealert': notiContent.type === 'error', 'icon-approval': notiContent.type === 'success'}"></i>
            </div>
            <div>
              <h3>{{pageContent[notiContent.type+'Msg'][notiContent.content].header}}</h3> 
              <span class="message">{{pageContent[notiContent.type+'Msg'][notiContent.content].msg}}</span>
            </div>
          </div>
        <p *ngIf="appleRenewal" >{{pageContent.subdescription.renew}}</p>
        <p> {{pageContent.subdescription.download[0]}} <a href="javascript:void(0)" (click)="downloadCSR()" >{{pageContent.subdescription.download[1]}}</a> {{pageContent.subdescription.download[2]}}   </p>
      
        <p *ngIf="!appleRenewal"> {{pageContent.subdescription.linkToAppleCertificate[0]}} <a target="_blank" href="https://identity.apple.com/pushcert"> {{pageContent.subdescription.linkToAppleCertificate[1]}} </a> {{pageContent.subdescription.linkToAppleCertificate[2]}}</p>
        <p *ngIf="appleRenewal"> {{pageContent.subdescription.linkToAppleCertificateRenewal[0]}} <a target="_blank" href="https://identity.apple.com/pushcert"> {{pageContent.subdescription.linkToAppleCertificateRenewal[1]}} </a> {{pageContent.subdescription.linkToAppleCertificateRenewal[2]}}</p>

        <p [innerHtml]="pageContent.attachFile"></p>
      
        <div>
          <div class="form-group">
            <div class="col-sm-12 col-md-12 file-upload-container">
              <label [ngClass]="{'label-block': fileName}"> File name: {{fileName}} </label>
              <button  attr.aria-label="{{pageContent.buttons.choose}}" class="btn btn-secondary" (click)="fileInput.click()">{{pageContent.buttons.choose}}</button>
              <input id="file-upload" type="file" (change)="handleFileUpload($event)" #fileInput style="display: none" />
              <p class = "filetype-error-msg" *ngIf="inValidfiletype"> <i class = "icon-badgealert"> </i>{{pageContent.invalidFile}}</p>
              <div class="csr-link">
                  <a  href="javascript:void(0)" (click)="navigateToStepOne()">{{pageContent.backToStep1}}</a>
              </div>
            </div>
          </div>
      <!--    <label>File name:</label><i> Upload File name</i> -->
        </div>
      
        <p *ngIf="fileName" [innerHtml]="pageContent.notes"></p>
      
      
        <hr class="clear" />
        <div class="row">
          <div class="col-sm-12 col-md-12 text-right button-section">
            <button [disabled]="isDisabled" [checkImpersonator]="fileName === ''" (click)="uploadAppleCertificate()" class="btn btn-secondary pull-right" attr.aria-label="{{pageContent.buttons.AccessibilityText}}"> {{pageContent.buttons.submit}}  </button>
            <a href="javascript:void(0)" class="btn btn-link btn-block btn-cancel" attr.aria-label="{{pageContent.buttons.cancel}}" (click)="navigateToStepOne()"> {{pageContent.buttons.cancel}}  </a>
          </div>
        </div>
      </div>
</main>
